import type { SaveArchives, SaveNode, SaveStatus } from "./types";

function object(value: unknown): Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
}
function array(value: unknown): unknown[] { return Array.isArray(value) ? value : []; }
function integer(value: unknown, fallback: number): number {
  if (typeof value !== "number" && typeof value !== "string" || value === "") return fallback;
  const number = Number(value);
  return Number.isSafeInteger(number) ? number : fallback;
}
export function decodeSave(value: unknown): SaveNode | null {
  const raw = object(value);
  const id = integer(raw.id, 0);
  if (id <= 0) return null;
  const time = raw.created_at ?? raw.update_time;
  return {
    id, user_id: integer(raw.user_id, 0), game_id: integer(raw.game_id, 0),
    device_id: typeof raw.device_id === "string" ? raw.device_id : "",
    created_at: typeof time === "string" || typeof time === "number" ? time : null,
    remark: typeof raw.remark === "string" ? raw.remark : "",
    status: integer(raw.status, 1),
    current_profile: raw.current_profile === true || raw.current_profile === 1 || raw.current_profile === "1" ? 1 : 0,
  };
}
export function decodeSaveStatus(value: unknown): SaveStatus | null {
  const profile = decodeSave(object(value).profile);
  return profile ? { profile } : null;
}
export function decodeSaveArchives(value: unknown): SaveArchives {
  const raw = object(value);
  return {
    tag_profile: decodeSave(raw.tag_profile),
    month: array(raw.month).map((month) => {
      const item = object(month);
      return {
        title: typeof item.title === "string" ? item.title : "",
        day: array(item.day).map((day) => {
          const item = object(day);
          return {
            title: typeof item.title === "string" ? item.title : "",
            Profiles: array(item.Profiles ?? item.profiles).map(decodeSave).filter((save): save is SaveNode => save !== null),
          };
        }),
      };
    }),
  };
}
